import * as React from 'react';

const CurrentLocation32 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 16, r: 16 }), /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 16, r: 7 }));
CurrentLocation32.Size = 32;
CurrentLocation32.Title = "CurrentLocation";

export { CurrentLocation32 as default };
